import axios from 'axios';
import { getToken,removeToken } from '@/utils/auth';
import { getCacheUserInfo } from '@/utils/auth';
// import qs from 'qs'
// create an axios instance
const service = axios.create({
    // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    // withCredentials: true,
    timeout: 5000 // request timeout
})



// request interceptor
service.interceptors.request.use(

    config => {
    // do something before request is sent
        let uid = getCacheUserInfo().uid;
        let token = getToken()
        if (uid) {
            config.headers['uid'] = uid
        }
        if (token) {
            // let each request carry token
            // ['X-Token'] is a custom headers key
            // please modify it according to the actual situation
            config.headers['Authorization'] = token
        }
        // 调用生成需要好加  header content type，
        if (config.url.indexOf('-admin-template') == -1) {
            config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8;'
        }
        return config
    },
    error => {
        console.log("requesterr---",error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

    /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
    response => {
        const res = response.data
        if(response.data.code===9001||response.data.code===9002){
          window.localStorage.removeItem('userInfo');
          removeToken()
          window.location.reload();
          return
        }
        return res
    },
    error => {
        return Promise.reject(error)
    }
)

export default service
